import { Controller, useFormContext } from "react-hook-form";
import type { RegisterOptions } from "react-hook-form";
import type { DateInputOptions } from "./DateInputComponent";
import { DateInputComponent } from "./DateInputComponent";

export interface DateInputProps extends DateInputOptions {
  dataTestId?: string;
  disabled?: boolean;
  fullWidth?: boolean;
  isStatic?: boolean;
  maxDate?: string;
  minDate?: string;
  minuteIncrement?: number;
  name: string;
  required?: boolean;
  rules?: RegisterOptions;
  withIcon?: boolean;
}

export const DateInput = ({
  name,
  rules = {},
  disabled = false,
  fullWidth = false,
  minDate = "",
  maxDate = "",
  minuteIncrement = 15,
  required = false,
  withIcon = false,
  isStatic = false,
  dataTestId = "",
  ...passThrough
}: DateInputProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({
        field: { onChange, value },
      }: {
        field: { onChange: (date: string) => void; value: string };
      }) => (
        <DateInputComponent
          onChange={onChange}
          value={value}
          fullWidth={fullWidth}
          disabled={disabled}
          minDate={minDate}
          maxDate={maxDate}
          withIcon={withIcon}
          required={required}
          minuteIncrement={minuteIncrement}
          isStatic={isStatic}
          dateInputOptions={passThrough}
          dataTestId={dataTestId}
        />
      )}
    />
  );
};
